_ = require 'underscore'
{ PowerUpItemType } = require 'app/common/components/power-up'
BaseDirectoryView = require './base-directory-view'
DirectoryPluginItemView = require './directory-plugin-item-view'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('directory')

class DirectorySearchComponent extends React.Component
  displayName: 'Directory Search'

  render: t.renderable ->
    t.div '.directory-content-body', =>
      if @props.isEmpty
        t.div '.directory-search-empty', =>
          t.p =>
            t.formatText 'bummer-no-search-results-for'
            t.span =>
              t.text '"' + @props.searchTerm + '"'
      else
        t.div '.directory-listing'

module.exports = class DirectorySearchView extends BaseDirectoryView
  eventSource: -> 'boardDirectorySearch'

  renderContent: ->
    React.createElement DirectorySearchComponent, {
      searchTerm: @options.searchTerm
      isEmpty: _.isEmpty @options.plugins
    }

  render: ->
    super
    contentContainer = @$el.find('.directory-listing')
    contentContainer.empty()

    { plugins, currentPage, directoryView, searchTerm } = @options

    pluginViews = _.map plugins, (plugin) =>
      @subview(DirectoryPluginItemView, @model, {
        atomType: PowerUpItemType.Description
        currentPage
        plugin
        directoryView
      }, plugin.id)

    @appendSubviews(pluginViews, contentContainer)

    enabledPlugins = directoryView.getEnabledPlugins()
    listedPowerUpsEnabled = _.intersection(_.map(plugins, 'id'), _.map(enabledPlugins, 'id'))

    directoryView.trackScreenEvent @eventSource(),
      totalListed: plugins.length
      totalListedEnabled: listedPowerUpsEnabled.length
      totalEnabled: enabledPlugins.length
      allPowerUpsEnabled: _.map(enabledPlugins, 'id')
      listedPowerUpsEnabled
    @
